





































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
declare var $: any;
@Component({})
export default class Sidebar extends Vue {
  @Getter('menus') menus: any;
  @Getter('user') user: any;
  private mounted() {
    $('.metismenu').metisMenu();
  }
  get accountType() {
    return this.user.roles[0]
  }

}
